import React from "react";
import { connect } from "react-redux";
import { FormControl } from "react-bootstrap";

import { setDistrict } from "../actions";
import { bindActionCreators } from "redux";
import { mapTest } from "../../../pages/products/map.test";

class DistrictInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.onChange = this.onChange.bind(this);
  }

  onChange(value) {
    this.props.setDistrict(value.target.value);
  }

  render() {
    const { district, loading } = this.props;
    return (
      <div>
        Bairro
        <FormControl id= {mapTest.createClient.clientAddressDistrict} type="text" value={district} onChange={this.onChange} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
  district: state.district,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setDistrict,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DistrictInput);



// WEBPACK FOOTER //
// ./src/components/parts/address-component/disctrict/index.jsx